import { useState } from "react";
import { Divider, Icon, Loader } from "semantic-ui-react";

import { FilePreview } from "components";
import "components/Images/Images.scss";
import { downloadFile } from "utils/common";

import type { QuestionResultImage, QuestionResultImageID } from "models";

type ImagesProps = {
  canDelete?: boolean;
  images?: QuestionResultImage[];
  onDeleteRequest?: (data: QuestionResultImage) => void;
  onChangeVisibility?: (data: QuestionResultImage) => void;
};

const isClickOutsideBtnGroup = (target: EventTarget | null) => target instanceof Element && !target.closest(".btn-group");

export const Images = ({ images, canDelete, onDeleteRequest, onChangeVisibility }: ImagesProps) => {
  const [shownPreviewIndex, setShownPreviewIndex] = useState<number | null>(null);
  const [downloadingId, setDownloadingId] = useState<QuestionResultImageID | null>(null);

  if (!images) return null;

  const handleDownloadImage = async (image: QuestionResultImage) => {
    setDownloadingId(image.id);
    await downloadFile(image.url);
    setDownloadingId(curr => (curr === image.id ? null : curr));
  };

  return (
    <>
      <div className="Snooze-Images">
        {images.map((image, index) => {
          return (
            <div key={image.id} className="image-view" onClick={({ target }) => isClickOutsideBtnGroup(target) && setShownPreviewIndex(index)}>
              <img src={image.url} alt="" />
              <Divider />
              <div className="btn-group">
                {onChangeVisibility && (
                  <div className="image-wrapper" onClick={() => onChangeVisibility(image)}>
                    <Icon className={`${image.visible_to_customer ? "eye green" : "eye slash red"}`} />
                  </div>
                )}
                <div className="image-wrapper" onClick={() => downloadingId !== image.id && handleDownloadImage(image)}>
                  {downloadingId === image.id ? <Loader active inline size="tiny" /> : <Icon className="download blue" />}
                </div>
                {onDeleteRequest && canDelete && (
                  <div className="image-wrapper" onClick={() => onDeleteRequest(image)}>
                    <Icon className="trash grey" />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <FilePreview files={images} previewIndex={shownPreviewIndex} setPreviewIndex={setShownPreviewIndex} />
    </>
  );
};
